import { useState } from 'react';

const faqs = [
  {
    q: '4399漫画网上的漫画可以免费阅读吗？',
    a: '可以。4399漫画网提供的漫画资源均支持在线免费阅读，无需付费即可追更连载作品，也能浏览全部完结作品库，让你放心追漫。',
  },
  {
    q: '如何快速找到我想看的漫画？',
    a: '你可以在首页顶部的搜索框输入漫画名称，或在「全部漫画」页按分类筛选、按热度/更新/完结状态排序，快速定位目标作品。',
  },
  {
    q: '热门排行是如何产生的？',
    a: '热门排行综合了各漫画的阅读量、收藏人数与更新时间等数据，系统实时计算并展示当前最受欢迎的人气作品，帮助你发现大家都在追的漫画。',
  },
  {
    q: '新上架作品和完结作品有什么区别？',
    a: '新上架作品是最新收录、近期更新的连载漫画；完结作品则是已经更新完整本故事、可一口气读完的漫画库。两者都可以通过顶部导航或列表页筛选进入。',
  },
  {
    q: '漫画多久更新一次？',
    a: '大部分连载漫画会随原作进度保持高频更新，热门作品通常每周多次更新，完结作品则持续补充入库。你可以关注作品页的最新章节动态。',
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-question-line"></i> 常见问题
          </p>
          <h2 className="mt-1 font-display text-2xl text-foreground-900 md:text-3xl">关于追漫，你可能想问</h2>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                aria-expanded={open === i}
              >
                <h4 className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</h4>
                <i className={`ri-add-line shrink-0 text-lg text-primary-600 transition-transform ${open === i ? 'rotate-45' : ''}`}></i>
              </button>
              {open === i && <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((f) => ({
                '@type': 'Question',
                name: f.q,
                acceptedAnswer: { '@type': 'Answer', text: f.a },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}